<template>
    <vPerformanceUnitSnapshotComponent :postList="postList" v-if="flag"></vPerformanceUnitSnapshotComponent>
</template>
<script>
import vPerformanceUnitSnapshotComponent from '../../listComponent/basicdata/performance/performanceUnitSnapshotComponent.vue';
export default {
    name: 'performance_unit',
    components: {
        vPerformanceUnitSnapshotComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>